import { type ModalProps, Typography } from '@mui/material';
import { Modal } from 'components/Modal';
import { type FC, useState } from 'react';
import { CoverageDetailsTriggerStyle } from '../CoverageDetails.styles';
import type { CoverageDetailsProps } from '../CoverageDetails.types';
import CoverageDetailsContent from '../CoverageDetailsContent/CoverageDetailsContent';

const CoverageDetailsModal: FC<CoverageDetailsProps> = ({ detailsKey, triggerText }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleIsOpenToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const handleClose: ModalProps['onClose'] = (_e, _reason) => {
    handleIsOpenToggle();
  };

  return (
    <>
      <Typography sx={CoverageDetailsTriggerStyle} onClick={handleIsOpenToggle}>
        {triggerText}
      </Typography>

      <Modal
        title="Coverage for your operations"
        open={isOpen}
        onClose={handleClose}
        onCloseIconClick={handleIsOpenToggle}
        modalContent={<CoverageDetailsContent detailsKey={detailsKey} />}
      />
    </>
  );
};

export default CoverageDetailsModal;
